import {TrafficLightRange} from '@models/machine/traffic-light/traffic-light-range';

export class TrafficLightConfiguration {
  signalId: number = -1;
  signalName: string = '';
  statusEventPageId: number = -1;
  statusEventPageName: string = '';
  statusEventPageMenuId: string = '';
  failure: TrafficLightRange = new TrafficLightRange();
  running: TrafficLightRange = new TrafficLightRange();
  warning: TrafficLightRange = new TrafficLightRange();
  usingStatusEventPage: boolean = false;
}